import { render, staticRenderFns } from "./AccountHolderExpenseSchedule.vue?vue&type=template&id=2718aa35&scoped=true"
import script from "./AccountHolderExpenseSchedule.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseSchedule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718aa35",
  null
  
)

export default component.exports